<template>
  <div>
    <div class="grid --with-gutter" v-if="ispaid">
      <div v-if="logo || fullLogoPath" class="grid-cell">
        <a
          data-track-click="ratetable.revenueclick"
          href="#"
          v-bind:data-clicktype="clicktype ? clicktype : 8"
          data-eventtype="click"
          data-name="advertiserlogo"
          class="br-rt-logo track +mg-bottom-xs +text-left"
        >
          <img v-if="fullLogoPath" v-bind:src="fullLogoPath" alt="logo" />
          <img
            v-else-if="logo"
            v-bind:src="'https://www.brimg.net/system/img/inst/' + logo"
            alt="logo"
          />
        </a>
      </div>
      <div v-else class="grid-cell">
        <a
          data-track-click="ratetable.revenueclick"
          href="#"
          data-clicktype="2"
          data-eventtype="click"
          data-name="advertiserlink"
          class="rate-table__row-copy --dark-gray track +mg-bottom-sm"
        >
          {{ advertiser }}
        </a>
      </div>
    </div>
    <div v-else class="rate-table__row-copy --dark-gray">
      <template v-if="ispaid === true">
        <a
          data-track-click="ratetable.revenueclick"
          href="#"
          data-clicktype="8"
          data-eventtype="click"
          data-name="advertiserlink"
          class="rate-table__row-copy --dark-gray track"
        >
          {{ advertiser }}
        </a>
      </template>
      <template v-else>
        {{ advertiser }}
      </template>
    </div>
  </div>
</template>

<script>
export default {
  props: [
    'logo',
    'fullLogoPath',
    'ispaid',
    'advertiser',
    'cpc',
    'islocal',
    'clicktype'
  ]
}
</script>
